import { ServiceClient } from '../../../../../Services/ServiceClient';
import { teamPageReducerTypes } from '../../../Reducer';
import { addressReducerTypes } from './Reducer';

export const addressFormId = 'addressForm';

export const changeAddressForAgent = (agentCode, codePrefix, addressId, addressDispatch, teamPageDispatch) => {
  ServiceClient.setAddressForAgent(agentCode, addressId, () => {
    ServiceClient.getAddressListForTeam(codePrefix, list => {
      addressDispatch({
        type: addressReducerTypes.setSelectedAddress,
        list,
      });
      teamPageDispatch({
        type: teamPageReducerTypes.updateAddressInfo,
        isModalOpenedOnTeamLevel: false,
        isInherited: false,
      });
    });
  });
};

export const inheritAddressFromTeam = (agentCode, codePrefix, addressDispatch, teamPageDispatch) => {
  ServiceClient.inheritAddressFromTeam(agentCode, () => {
    ServiceClient.getAddressListForTeam(codePrefix, list => {
      addressDispatch({
        type: addressReducerTypes.inheritAddressFromTeam,
        list,
      });
      teamPageDispatch({
        type: teamPageReducerTypes.updateAddressInfo,
        isModalOpenedOnTeamLevel: false,
        isInherited: true,
      });
    });
  });
};
